import React from 'react';
import IntlMessages from 'Util/IntlMessages';
import icCompany1 from 'Assets/img/sign/ic_company.png';
import icCompany2 from 'Assets/img/sign/ic_company@2x.png';
import icCompany3 from 'Assets/img/sign/ic_company@3x.png';
import icPersonal1 from 'Assets/img/sign/ic_personal.png';
import icPersonal2 from 'Assets/img/sign/ic_personal@2x.png';
import icPersonal3 from 'Assets/img/sign/ic_personal@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { BUSINESS_TYPE } from '../../constants';

const icCompany = getImageSet([icCompany1, icCompany2, icCompany3]);
const icPersonal = getImageSet([icPersonal1, icPersonal2, icPersonal3]);

const SelectForm = ({ onGoVerify }) => {
  return (
    <div className="join-vi-user-type-wrapper">
      <div className="join-vi-user-container cursor-pointer no-drag" onClick={() => onGoVerify({ _businessType: BUSINESS_TYPE.INDIVIDUAL })}>
        <div className="join-vi-user-type-content">
          <div className="join-vi-user-type-title">
            <IntlMessages id="signIn.join.company" />
          </div>
          <div className="join-vi-user-type-sub">
            <IntlMessages id="signIn.join.company.sub" />
          </div>
        </div>
        <div className="join-vi-user-image">
          <img {...icCompany} alt="company" />
        </div>
      </div>
      <div className="join-vi-user-container cursor-pointer no-drag" onClick={() => onGoVerify({ _businessType: BUSINESS_TYPE.FREELANCER })}>
        <div className="join-vi-user-type-content">
          <div className="join-vi-user-type-title">
            <IntlMessages id="signIn.join.personal" />
          </div>
          <div className="join-vi-user-type-sub">
            <IntlMessages id="signIn.join.personal.sub" />
          </div>
        </div>
        <div className="join-vi-user-image">
          <img {...icPersonal} alt="personal" />
        </div>
      </div>
    </div>
  );
};

export default SelectForm;
